export default function HomeCard({ title, desc, icon, gradient, onClick, count }) {
  return (
    <div
      className="card"
      onClick={onClick}
      style={{
        padding: "32px",
        cursor: "pointer",
        transition: "all 0.3s",
        position: "relative",
        overflow: "hidden",
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.transform = "translateY(-5px)";
        e.currentTarget.style.boxShadow = "0 20px 40px rgba(0,0,0,0.4)";
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 8px 32px rgba(0,0,0,0.3)";
      }}
    >
      <div
        style={{
          width: "70px",
          height: "70px",
          background: gradient,
          borderRadius: "18px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "20px",
          fontSize: "28px",
          boxShadow: "0 8px 25px rgba(0,0,0,0.3)",
        }}
      >
        {icon}
      </div>
      <h3
        style={{
          margin: "0 0 8px",
          fontSize: "20px",
          fontFamily: "'Space Grotesk', sans-serif",
          fontWeight: "600",
        }}
      >
        {title}
      </h3>
      <p
        style={{ margin: 0, color: "rgba(255,255,255,0.5)", fontSize: "14px" }}
      >
        {desc}
      </p>
      {count > 0 && (
        <span
          style={{
            position: "absolute",
            top: "20px",
            right: "20px",
            background: gradient,
            padding: "6px 14px",
            borderRadius: "20px",
            fontSize: "14px",
            fontWeight: "600",
          }}
        >
          {count}
        </span>
      )}
    </div>
  );
}
